import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from '@heroui/react';
import React from 'react';

import { ProductsTableProps, OrderProduct } from './types';

export const ProductsTable: React.FC<ProductsTableProps> = ({
  isLoading,
  products,
}) => {
  const columns = [
    { key: 'externalId', label: 'Product ID' },
    { key: 'name', label: 'Product Name' },
    { key: 'unit', label: 'Unit' },
    { key: 'amount', label: 'Amount' },
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold text-foreground">Products</h3>

      <Table
        aria-label="Products table"
        classNames={{
          base: 'overflow-visible',
          table: 'min-h-[100px]',
        }}
      >
        <TableHeader columns={columns}>
          {(column) => (
            <TableColumn key={column.key}>{column.label}</TableColumn>
          )}
        </TableHeader>

        <TableBody
          items={products}
          isLoading={isLoading}
          emptyContent={
            isLoading ? 'Loading products...' : 'No products in this order'
          }
        >
          {(product: OrderProduct) => (
            <TableRow key={product.id}>
              <TableCell>
                <span className="text-sm text-default-600">
                  {product.externalId || '---'}
                </span>
              </TableCell>
              <TableCell>
                <span className="text-sm font-medium text-foreground">
                  {product.name}
                </span>
              </TableCell>
              <TableCell>
                <span className="text-sm text-default-600">{product.unit}</span>
              </TableCell>
              <TableCell>
                <span className="text-sm font-medium text-foreground">
                  {product.amount}
                </span>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
